<template>
  <Card
    :clickable="true"
    :elevation="2"
    custom-classes="border-1 border-solid border-grey-divider-subdued"
    :show-checkmark="false"
    class="w-full mb-16 !p-0"
    :selected="selected"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <div class="flex h-72 flex-row items-center gap-16 px-16 py-20">
      <component :is="icon" class="shrink-0" :width="32" :height="32" />
      <p class="text-body text-grey-header mb-0">{{ label }}</p>
    </div>
  </Card>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import Card from './Card.vue';

defineProps<{
  icon: Component;
  label: string;
  selected?: boolean;
  disabled?: boolean;
}>();

defineEmits<{
  click: [];
}>();
</script>
